import { css } from 'styled-components';

export const pages = css`
    /* Home Page */
    --home-hero-background: linear-gradient(189deg, #4162CC 0%, #264BC5 100%);
    --home-hero-title-color: white;
    --home-hero-subtitle-color: white;

    /* Subscription Page */
    --subscription-hero-background: var(--color-blue-20, #C7D5F9);
    --subscription-hero-title-color: black;
    --subscription-hero-subtitle-color: black;
`;
